import PropTypes from 'prop-types'
import { formatearFecha } from '../helpers/helper'
import styles from './ItemLista.module.css'

export const ItemLista = ({
  lista,
  onEditar,
  onEliminar,
  esVenta = false,
  onVerItems
}) => {
  if (!lista) {
    return null
  }

  const cantidadItemsCalc = () => {
    const countFields = [
      lista.cantidadItems,
      lista.cantItems,
      lista.totalItems,
      lista.totalPublicaciones,
      lista.total
    ]
    const hasCountField = countFields.some((v) => v !== undefined && v !== null)
    const num = Number(countFields.find((v) => v !== undefined && v !== null) ?? 0)

    const arrays = [lista.grilla, lista.items, lista.publicaciones]
    const arraysWithData = arrays.filter((a) => Array.isArray(a))
    const maxArray = arraysWithData.reduce((acc, arr) => Math.max(acc, arr.length), 0)
    const hasArray = arraysWithData.length > 0

    if (!hasCountField && !hasArray) {
      return null
    }
    return Math.max(num, maxArray)
  }

  const cantidadItems = cantidadItemsCalc()
  const titulo = lista.nombre ?? lista.nombreLista ?? 'Sin nombre'

  if (esVenta) {
    return (
      <div className={styles.card}>
        <h4 className={styles.cardTitle}>{titulo}</h4>
        <div className={styles.cardBody}>
          <div className={styles.textMuted}>
            <p>
              <strong>Nombre: </strong>
              {titulo}
            </p>
            <p>
              <strong>Vigencia: </strong>
              {formatearFecha(lista.vigenciaDesde, 'F')} -
              {formatearFecha(lista.vigenciaHasta, 'F')}
            </p>

            <p>
              <strong>Vigencia oferta: </strong>
            </p>
            <p>
              {formatearFecha(lista.ofertaDesde, 'F')} -
              {formatearFecha(lista.ofertaHasta, 'F')}
            </p>
            <p>
              <strong>Descuento: </strong>
              {lista.porcDcto ?? '-'}%
            </p>
          </div>
        </div>

        {onEditar && (
          <div className={styles.btnContainer}>
            <button
              type="button"
              className={`${styles.btn} ${styles.btnOutlinePrimary}`}
              onClick={() => onEditar(lista)}
              title="Editar lista"
            >
              <i className="bi bi-pencil"></i>
            </button>
            {onVerItems && (
              <button
                type="button"
                className={`${styles.btn} ${styles.btnOutlinePrimary}`}
                onClick={() => onVerItems(lista)}
                title="Ver y editar publicaciones"
              >
                <i className="bi bi-list-ul"></i>
              </button>
            )}
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={styles.card}>
      <h4 className={styles.cardTitle}>{titulo}</h4>
      <div className={styles.cardBody}>
        <div className={styles.textMuted}>
          <p>
            <strong>Vigencia: </strong>
            {formatearFecha(lista.vigenciaDesde, 'F')} -
            {formatearFecha(lista.vigenciaHasta, 'F')}
          </p>
          <p>
            <strong> Cantidad de items lista: </strong>
            {cantidadItems ?? '-'}
          </p>
        </div>
      </div>

      <div className={styles.btnContainer}>
        <button
          type="button"
          className={`${styles.btn} ${styles.btnOutlinePrimary}`}
          onClick={() => onEditar(lista)}
        >
          <i className="bi bi-pencil"></i>
        </button>

        <button
          type="button"
          className={`${styles.btn} ${styles.btnOutlineDanger}`}
          onClick={() => onEliminar(lista)}
        >
          <i className="bi bi-trash"></i>
        </button>
      </div>
    </div>
  )
}

ItemLista.propTypes = {
  lista: PropTypes.object,
  onEditar: PropTypes.func,
  onEliminar: PropTypes.func,
  onVerItems: PropTypes.func,
  esVenta: PropTypes.bool
}
